
import { parseQueryString } from '../util/urlutils';

function triggerViewItemList() {
  try {
    const pageEl = document.querySelector('.page');
    if (!pageEl) return;

    const action = pageEl.getAttribute('data-action');
    if (action !== 'Search-Show') return; // Only trigger for Search-Show

    // Select only the latest .product-tiles container (Load More appends new ones)
    const productTilesContainers = document.querySelectorAll('.product-grid .product-tiles');
    if (!productTilesContainers || productTilesContainers.length === 0) return;

    const latestTilesContainer = productTilesContainers[productTilesContainers.length - 1];
    if (!latestTilesContainer) return;

    const productTiles = latestTilesContainer.querySelectorAll('.product-tile');
    if (!productTiles || productTiles.length === 0) return;

    // Determine pagination or tracking info
    const gridFooter = document.querySelector('.grid-footer');
    const pageNumber = gridFooter ? parseInt(gridFooter.getAttribute('data-page-start'), 10) : 0;

    const queryString = pageEl.getAttribute('data-querystring') || '';
    const params = new URLSearchParams(queryString);
    const itemListName = params && params.has('cgid')
      ? `PLP_${params.get('cgid')}`
      : 'PLP_Search';

    const items = Array.from(productTiles).map((tile, index) => {
      const trackingAttr = tile.getAttribute('data-tracking');
      if (!trackingAttr) return null;

      try {
        const trackingData = JSON.parse(trackingAttr);
        const itemList = trackingData.item_list || {};
        const position = pageNumber + index + 1;
        const item = trackingData.item || {};
        itemList.index = position;
        itemList.item_list_name = itemListName;

        // Constructor Custom Event
        document.dispatchEvent(new CustomEvent('constructor:itemView', {
          detail: {
            item_id: item.id,
            item_name: item.name,
            variation_id: item.id,
            price: item.price,
            position,
            list_name: itemListName,
          },
        }));
        return itemList;
      } catch (err) {
        window.console.warn('Invalid JSON in data-tracking:', err);
        return null;
      }
    }).filter(Boolean);

    if (items.length > 0) {
      window.dataLayer = window.dataLayer || [];
      const currency = pageEl.getAttribute('data-currency') || '';
      window.dataLayer.push({
        event: 'eec.view_item_list',
        ecommerce: {
          currency,
          items,
        },
      });

      document.dispatchEvent(new CustomEvent('constructor:itemViewList'));
    }
  } catch (e) {
    window.console.error('❌ Error in GTM view_item_list script:', e);
  }
}

function triggerSortChange(sortChange, trigger) {
  if (!sortChange || !trigger || !trigger.value) return;

  const query = parseQueryString(trigger.value);
  if (!query || !query.srule) return;

  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'sortByChanged',
    eventData: {
      elementChanged: query.srule,
    },
  });
}

export default {
  triggerViewItemList,
  triggerSortChange,
};
